import {
    DialogContentText,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    TextField,
} from '@material-ui/core';
import { useState } from 'react';
import addKit from '../actions/addKit';
import type { KitType } from '../actions/getKitTypes';
import Dialog from '../components/Dialog';
import { ReactComponent as TestTubeIcon } from '../icons/testTube.svg';
import useStore from '../store/store';

interface NewKitFormProps {
    open: boolean;
    onClose: () => void;
    memberId: number;
    onTestAdded: () => void;
    isAdmin?: boolean;
}

const NewKitForm = ({
    open,
    onClose,
    memberId,
    onTestAdded,
    isAdmin = false,
}: NewKitFormProps) => {
    const kitTypes: KitType[] = useStore((state) => state.kitTypes || []);
    const [kitTypeId, setKitTypeId] = useState(kitTypes?.[0]?.KitTypeId ?? -1);

    const handleSubmit = (e: React.SyntheticEvent) => {
        e.preventDefault();
        const target = e.target as typeof e.target & {
            kitTypeId: { value: number };
            nickname?: { value: string };
        };
        const kitTypeId = target.kitTypeId.value;
        const nickname = target.nickname?.value;

        addKit({
            memberId,
            kitTypeId: Number(kitTypeId),
            ...(nickname && { nickname }),
            isAdmin,
        });
        onTestAdded();
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            onSubmit={handleSubmit}
            maxWidth="xl"
            title="Order Test"
            icon={<TestTubeIcon />}
        >
            <DialogContentText>
                Test ID:{' '}
                {kitTypes.find(
                    (kitType: KitType) => kitType.KitTypeId === kitTypeId
                )?.KitTypeCatalogueId ?? 'N/A'}
            </DialogContentText>
            <FormControl fullWidth margin="dense">
                <InputLabel id="kit-type-select-label">Test type</InputLabel>
                <Select
                    labelId="kit-type-select-label"
                    id="kit-type-select"
                    name="kitTypeId"
                    value={kitTypeId}
                    label="Test Type"
                    onChange={(e) => setKitTypeId(Number(e.target.value))}
                    required
                    displayEmpty
                >
                    {kitTypes.map((kitType) => (
                        <MenuItem
                            key={kitType.KitTypeId}
                            value={kitType.KitTypeId}
                        >
                            {kitType.Type}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <TextField
                margin="dense"
                id="nickname"
                name="nickname"
                label="Nickname"
                type="text"
                fullWidth
                variant="outlined"
                inputProps={{
                    maxLength: 100,
                }}
            />
        </Dialog>
    );
};

export default NewKitForm;
